// import React, { Fragment, useState, useEffect } from "react";
// import "../Reporting.css";
// import ReportingModals from "../../../../shared/Modals/ReportingModals";
// import arrowImg from "../../../../assets/purple.svg";
// import { listAppointmentsYearByYear } from "../api";
// import { Group } from "@visx/group";
// import { AxisLeft, AxisBottom } from "@visx/axis";
// import { scaleLinear, scaleBand } from "@visx/scale";
// import { LinePath } from "@visx/shape";
// import { Tooltip, useTooltip } from "@visx/tooltip";
// import { ParentSize } from "@visx/responsive";
// import { curveMonotoneX } from "@visx/curve";

// const AppointmentsYear = (props) => {
//   const [lgShow, setLgShow] = useState(false);
//   const [data, setData] = useState([]);
//   const { showTooltip, hideTooltip, tooltipData, tooltipLeft, tooltipTop } = useTooltip();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await listAppointmentsYearByYear();
        
//         // Get the last 12 months of data or all if less than 12
//         const last12Months = res.slice(-12);
//         setData(last12Months);
//       } catch (error) {
//         console.error("Error fetching appointments:", error);
//       }
//     }
//     fetchData();
//   }, []);

//   // Chart component
//   const Chart = ({ width, height }) => {
//     // Early return if no data
//     if (!data.length) return null;

//     // Chart dimensions
//     const margin = { top: 20, right: 30, bottom: 40, left: 50 };
//     const innerWidth = width - margin.left - margin.right;
//     const innerHeight = height - margin.top - margin.bottom;

//     // Scales
//     const xScale = scaleBand({
//       domain: data.map(d => `${d.month} ${d.year}`),
//       range: [0, innerWidth],
//       padding: 0.2,
//     });

//     const yScale = scaleLinear({
//       domain: [0, Math.max(...data.map(d => d.totalCount)) * 1.1], // Add 10% padding
//       range: [innerHeight, 0],
//       nice: true,
//     });

//     // Colors
//     const lineColor = "#6b46c1"; // Purple color matching the arrow
//     const tickLabelColor = "#444";

//     return (
//       <div style={{ position: 'relative' }}>
//         <svg width={width} height={height}>
//           <Group left={margin.left} top={margin.top}>
//             {/* Grid lines */}
//             {yScale.ticks().map(tick => (
//               <line
//                 key={`grid-${tick}`}
//                 x1={0}
//                 x2={innerWidth}
//                 y1={yScale(tick)}
//                 y2={yScale(tick)}
//                 stroke="#e0e0e0"
//                 strokeDasharray="2,2"
//               />
//             ))}

//             {/* Axes */}
//             <AxisLeft
//               scale={yScale}
//               stroke="#888"
//               tickStroke="#888"
//               tickLabelProps={() => ({
//                 fill: tickLabelColor,
//                 fontSize: 11,
//                 textAnchor: 'end',
//                 dy: '0.33em',
//                 dx: '-0.33em',
//               })}
//               label="Appointments"
//               labelProps={{
//                 fill: tickLabelColor,
//                 fontSize: 12,
//                 textAnchor: 'middle',
//                 dx: -35,
//               }}
//             />
//             <AxisBottom
//               top={innerHeight}
//               scale={xScale}
//               stroke="#888"
//               tickStroke="#888"
//               tickLabelProps={() => ({
//                 fill: tickLabelColor,
//                 fontSize: 11,
//                 textAnchor: 'middle',
//                 dy: '0.33em',
//               })}
//               tickFormat={value => value.split(' ')[0].substring(0, 3)} // Show first 3 letters of month
//               label="Month"
//               labelProps={{
//                 fill: tickLabelColor,
//                 fontSize: 12,
//                 textAnchor: 'middle',
//                 dy: 35,
//               }}
//             />

//             {/* Line chart */}
//             <LinePath
//               data={data}
//               x={d => xScale(`${d.month} ${d.year}`) + xScale.bandwidth() / 2}
//               y={d => yScale(d.totalCount)}
//               stroke={lineColor}
//               strokeWidth={3}
//               curve={curveMonotoneX}
//             />

//             {/* Data points */}
//             {data.map((d, i) => (
//               <circle
//                 key={`circle-${i}`}
//                 cx={xScale(`${d.month} ${d.year}`) + xScale.bandwidth() / 2}
//                 cy={yScale(d.totalCount)}
//                 r={5}
//                 fill="#fff"
//                 stroke={lineColor}
//                 strokeWidth={2}
//                 onMouseEnter={() => {
//                   const x = xScale(`${d.month} ${d.year}`) + xScale.bandwidth() / 2;
//                   const y = yScale(d.totalCount);
//                   showTooltip({
//                     tooltipData: d,
//                     tooltipLeft: x + margin.left,
//                     tooltipTop: y + margin.top,
//                   });
//                 }}
//                 onMouseLeave={hideTooltip}
//                 style={{ cursor: 'pointer' }}
//               />
//             ))}
//           </Group>
//         </svg>

//         {tooltipData && (
//           <div
//             style={{
//               position: 'absolute',
//               top: tooltipTop - 40,
//               left: tooltipLeft,
//               transform: 'translateX(-50%)',
//               backgroundColor: 'white',
//               color: 'black',
//               padding: '0.5rem',
//               borderRadius: '4px',
//               boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//               fontSize: '12px',
//               pointerEvents: 'none',
//               zIndex: 9999,
//               width: 'auto',
//               minWidth: '120px',
//               textAlign: 'center',
//             }}
//           >
//             <div style={{ fontWeight: 'bold' }}>{`${tooltipData.month} ${tooltipData.year}`}</div>
//             <div>{`Appointments: ${tooltipData.totalCount}`}</div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <Fragment>
//       <div
//         onClick={(e) => { props?.check ? setLgShow(true) : e.preventDefault(); }}
//         className="d-flex align-items-center pl-4 pt-2"
//       >
//         <p className="review-txt"> Appointments month by month </p>
//         <img src={arrowImg} alt="" className="arrow-img ml-2" />
//       </div>
//       <div id={props?.divId} style={{ height: props?.check === false ? "400px" : "230px", width: "100%" }}>
//         <ParentSize>
//           {({ width, height }) => <Chart width={width} height={height} />}
//         </ParentSize>
//       </div>
//       {setLgShow ? (
//         <ReportingModals
//           setLgShow={setLgShow}
//           lgShow={lgShow}
//           show={1}
//           title={"Appointments month by month"}
//         />
//       ) : (
//         ""
//       )}
//     </Fragment>
//   );
// };

// export default AppointmentsYear;

import React, { Fragment, useState, useEffect, useMemo } from "react";
import "../Reporting.css";
import ReportingModals from "../../../../shared/Modals/ReportingModals";
import arrowImg from "../../../../assets/purple.svg";
import { listAppointmentsYearByYear } from "../api";
import { Group } from "@visx/group";
import { AxisLeft, AxisBottom } from "@visx/axis";
import { scaleLinear, scaleBand } from "@visx/scale";
import { LinePath, AreaClosed } from "@visx/shape";
import { useTooltip, TooltipWithBounds, defaultStyles } from "@visx/tooltip";
import { ParentSize } from "@visx/responsive";
import { curveMonotoneX } from "@visx/curve";
import { LinearGradient } from "@visx/gradient";

const AppointmentsYear = (props) => {
  const [lgShow, setLgShow] = useState(false);
  const [rawData, setRawData] = useState([]);
  const [filterRange, setFilterRange] = useState(12); // Default to 12 months
  const { showTooltip, hideTooltip, tooltipData, tooltipLeft, tooltipTop } = useTooltip();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await listAppointmentsYearByYear();
        setRawData(res);
      } catch (error) {
        console.error("Error fetching appointments:", error);
      }
    };
    fetchData();
  }, []);

  // Memoize filtered data to prevent unnecessary recalculations
  const chartData = useMemo(() => {
    return filterRange === "all" ? rawData : rawData.slice(-filterRange);
  }, [rawData, filterRange]);

  const Chart = ({ width, height }) => {
    if (!chartData.length || width < 10) return null;

    const margin = { top: 20, right: 30, bottom: 60, left: 50 };
    const innerWidth = width - margin.left - margin.right;
    const innerHeight = height - margin.top - margin.bottom;

    // Scales
    const xScale = scaleBand({
      domain: chartData.map(d => `${d.month} ${d.year}`),
      range: [0, innerWidth],
      padding: 0.2,
    });

    const yScale = scaleLinear({
      domain: [0, Math.max(...chartData.map(d => d.totalCount)) * 1.2],
      range: [innerHeight, 0],
      nice: true,
    });

    const getX = (d) => xScale(`${d.month} ${d.year}`) + xScale.bandwidth() / 2;
    const getY = (d) => yScale(d.totalCount);

    return (
      <div style={{ position: 'relative' }}>
        <svg width={width} height={height}>
          <LinearGradient id="area-gradient" from="#6b46c1" to="#6b46c1" fromOpacity={0.4} toOpacity={0} />
          <Group left={margin.left} top={margin.top}>
            {/* Grid */}
            {yScale.ticks(5).map(tick => (
              <line
                key={`grid-${tick}`}
                x1={0} x2={innerWidth}
                y1={yScale(tick)} y2={yScale(tick)}
                stroke="#f0f0f0"
              />
            ))}

            <AxisLeft
              scale={yScale}
              stroke="#ccc"
              tickLabelProps={() => ({ fill: "#666", fontSize: 10, textAnchor: 'end', dx: -5 })}
            />
            
            <AxisBottom
              top={innerHeight}
              scale={xScale}
              stroke="#ccc"
              tickFormat={val => val.split(' ')[0].substring(0, 3)}
              tickLabelProps={() => ({ fill: "#666", fontSize: 10, textAnchor: 'middle', dy: 5 })}
            />

            {/* The Gradient Area */}
            <AreaClosed
              data={chartData}
              x={getX}
              y={getY}
              yScale={yScale}
              strokeWidth={0}
              fill="url(#area-gradient)"
              curve={curveMonotoneX}
            />

            {/* The Main Line */}
            <LinePath
              data={chartData}
              x={getX}
              y={getY}
              stroke="#6b46c1"
              strokeWidth={3}
              curve={curveMonotoneX}
            />

            {/* Interaction Points */}
            {chartData.map((d, i) => (
              <circle
                key={`point-${i}`}
                cx={getX(d)}
                cy={getY(d)}
                r={tooltipData === d ? 7 : 4}
                fill={tooltipData === d ? "#6b46c1" : "#fff"}
                stroke="#6b46c1"
                strokeWidth={2}
                onMouseEnter={() => {
                  showTooltip({
                    tooltipData: d,
                    tooltipLeft: getX(d) + margin.left,
                    tooltipTop: getY(d) + margin.top,
                  });
                }}
                onMouseLeave={hideTooltip}
                style={{ cursor: 'pointer', transition: 'all 0.2s' }}
              />
            ))}
          </Group>
        </svg>

        {tooltipData && (
          <TooltipWithBounds
            key={Math.random()}
            top={tooltipTop}
            left={tooltipLeft}
            style={{
              ...defaultStyles,
              backgroundColor: '#2d3748',
              color: 'white',
              borderRadius: '8px',
              padding: '8px 12px',
            }}
          >
            <div style={{ fontSize: '10px', color: '#cbd5e0' }}>{tooltipData.year}</div>
            <div style={{ fontWeight: 'bold' }}>{tooltipData.month}</div>
            <div style={{ color: '#9f7aea', fontWeight: 'bold' }}>
              {tooltipData.totalCount} Appointments
            </div>
          </TooltipWithBounds>
        )}
      </div>
    );
  };

  return (
    <Fragment>
      <div className="reporting-header d-flex justify-content-between align-items-center pr-4">
        <div
          onClick={(e) => { props?.check ? setLgShow(true) : e.preventDefault(); }}
          className="d-flex align-items-center pl-4 pt-2 cursor-pointer"
        >
          <p className="review-txt">Appointments Analytics</p>
          <img src={arrowImg} alt="" className="arrow-img ml-2" />
        </div>

        {/* Dynamic Filter Controls */}
        <div className="filter-group">
          {[6, 12, "all"].map((range) => (
            <button
              key={range}
              onClick={() => setFilterRange(range)}
              className={`filter-btn ${filterRange === range ? 'active' : ''}`}
            >
              {range === "all" ? "All" : `${range}M`}
            </button>
          ))}
        </div>
      </div>

      <div id={props?.divId} className="chart-container" style={{ height: props?.check === false ? "400px" : "260px", width: "100%" }}>
        <ParentSize>
          {({ width, height }) => <Chart width={width} height={height} />}
        </ParentSize>
      </div>

      {lgShow && (
        <ReportingModals
          setLgShow={setLgShow}
          lgShow={lgShow}
          show={1}
          title={`Analytics: ${filterRange === 'all' ? 'All Time' : 'Last ' + filterRange + ' Months'}`}
        />
      )}

      <style jsx>{`
        .filter-group {
          background: #f4f4f9;
          padding: 4px;
          border-radius: 8px;
        }
        .filter-btn {
          border: none;
          background: transparent;
          padding: 4px 12px;
          font-size: 12px;
          border-radius: 6px;
          color: #666;
          cursor: pointer;
          transition: all 0.2s;
        }
        .filter-btn.active {
          background: #fff;
          color: #6b46c1;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          font-weight: 600;
        }
        .cursor-pointer { cursor: pointer; }
      `}</style>
    </Fragment>
  );
};

export default AppointmentsYear;